import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import Call4Impact from 'components/Cards/Call4ImpactCard';
import _ from 'lodash';
import { Carousel } from 'react-materialize';
import { getPublicCallsForImpact } from 'modules/callForImpact/actions';
import { EMBED } from 'constants/types';
import { EmbedCallCarouselWrapper } from './styles';

function EmbedCallForImpactCarousel(props) {
  const {
    ids, impactNetworks, callUrl, embedId,
  } = props;

  const [calls, setCalls] = useState([]);

  useEffect(() => {
    const paramsRequest = { embed_id: embedId };
    if (ids.length) {
      paramsRequest.ids = ids.join(',');
    } else if (impactNetworks.length) {
      paramsRequest.impact_networks = impactNetworks.join(',');
    }
    getPublicCallsForImpact(paramsRequest)
      .then((response) => {
        setCalls(response);
      });
  }, []);

  const handleClickCall = (call) => {
    window.top.location.href = callUrl.replace('*|callId|*', call.id);
  };

  if (!calls.length) {
    return calls;
  }

  const narrativesElements = _.map(calls, (call) => {
    return (
      <div key={call.id}>
        <Call4Impact
          data={call}
          type={EMBED}
          planId={0}
          onClickStart={handleClickCall}
        />
      </div>
    );
  });

  return(
    <EmbedCallCarouselWrapper>
      <Carousel
        carouselId='Carousel-2'
        options={{
          dist: -20,
          duration: 200,
          fullWidth: false,
          indicators: false,
          noWrap: false,
          numVisible: 6,
          onCycleTo: null,
          padding: -170,
          shift: 0,
        }}
      >
        {narrativesElements}
      </Carousel>
    </EmbedCallCarouselWrapper>
  );
}

EmbedCallForImpactCarousel.propTypes = {
  callUrl: PropTypes.string.isRequired,
  ids: PropTypes.array,
  impactNetworks: PropTypes.array,
  embedId: PropTypes.number.isRequired,
};

EmbedCallForImpactCarousel.defaultProps = {
  ids: [],
  impactNetworks: [],
};
export default EmbedCallForImpactCarousel;



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/Carousel/components/index.jsx